export default __webpack_public_path__ + "static/media/arrow-down-black.6abcfc7a.svg";